<atx-product-card-actions
  [addedToActiveList]="addedToActiveList$ | async"
  [currentVariantMedia]="currentVariantMedia"
  [deletable]="deletable"
  [isBookmarking]="isBookmarking$ | async"
  [previewAttributes]="previewAttributes$ | async"
  [product]="product$ | async"
  [replenishments]="replenishments$ | async"
  [showBookmarkIcon]="showBookmarkIcon"
  (addProductToActiveList)="addProductToActiveList()"
  (deleteFromProductList)="deleteFromProductList()"
  (removeProductFromActiveList)="removeProductFromActiveList()"
></atx-product-card-actions>
